export enum PageSettingEnum {
  EXTERNAL_EVENTS = 'is_external_events_enabled',
  SHOW_LEADERBOARD_PAGE = 'show_leaderboard_page',
  SHOW_CHALLENGES_PAGE = 'show_challenges_page'
}
